// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Header_container__1ni9g{width:100%;height:60px}", ""]);
// Exports
exports.locals = {
	"container": "Header_container__1ni9g"
};
module.exports = exports;
